import { defineComponent as _defineComponent } from 'vue';
import { BProgress, BProgressBar } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ProgressBar',
    props: {
        total: { default: 1 },
        note: { default: undefined },
        loading: { type: Boolean, default: false },
        okCount: { default: 0 },
        runningCount: { default: 0 },
        newCount: { default: 0 },
        errorCount: { default: 0 }
    },
    setup(__props) {
        const props = __props;
        // Not really a very generic ProgressBar - consider renaming to StateProgressBar.
        return { __sfc: true, props, BProgress, BProgressBar };
    }
});
